/* eslint-disable react/no-danger */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
import React from 'react';

export const ListHeader = ({ title, description, children }) => {
  return (
    <div className="sm:flex sm:items-center">
      <div className="sm:flex-auto">
        <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
        <p
          className="mt-2 text-sm text-gray-700"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
      <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">{children}</div>
    </div>
  );
};
